<app-top-navbar/>
<div class="wrapper page-email-unsubscription">
  <app-loyalty-club-header [useSubunitName]="true"/>
  <h3>{{ 'unsubscription.header' | translate }}</h3>
  @if (isTokenCorrect) {
    @if (settings$ | async; as settings) {
      @if (!isUnsubscribed) {
        <div class="form-group" [formGroup]="form">
          <div class="checkbox">
            <label [htmlFor]="'optout'">
              <input id="optout" type="checkbox" formControlName="isOptout">
              <span class="checkbox-material"><span class="check"></span></span>
              <i [innerHtml]="'unsubscribe_info' | unsubscribeTranslationKeyWithIdentifierType:identifierType | translate:{loyalty_club_name: settings.name, identifier: identifier}"></i>
            </label>
          </div>
        </div>
        @if (!isError) {
          <button class="btn btn-raised btn-primary btn-block"
                  [disabled]="form.get('isOptout')?.value === false || form.get('isOptout')?.value === null || form.get('isOptout')?.value === undefined"
                  (click)="unsubscribe()"
          >
            {{ 'unsubscription.unsubscribe_button' | translate }}
          </button>
        }
        @if (settings.loginEnabled) {
          <div class="tw-mt-[125px]">
            <small
                [innerHtml]="'unsubscription.hard_unsubscribe_info' | translate:{loyalty_club_name: settings.name} | translateCut:0"></small>
            <small><a
                (click)="navigateToMemberPage()">{{ 'unsubscription.hard_unsubscribe_info' | translate:{ loyalty_club_name: settings.name } | translateCut:1 }}</a></small>
          </div>
        }
      } @else {
        <app-alert alertType="info">
          {{ 'unsubscribed_info' | unsubscribeTranslationKeyWithIdentifierType:identifierType | translate }}
        </app-alert>
      }
    }
  } @else {
    @if (!isTokenCorrect) {
      <div class="form-group">
        <app-alert alertType="error">
          {{ 'unsubscription.token_invalid_error' | translate }}
        </app-alert>
      </div>
    }
  }
  @if (isError || !isTokenCorrect || isUnsubscribed) {
    <div class="form-group">
      @if (isError) {
        <app-alert alertType="error">
          {{ 'errors.generic' | translate }}
        </app-alert>
      }
      <button type="button"
              class="btn btn-raised btn-block btn-primary btn-sign-in"
              [routerLink]="['../../']">
        <span>{{ 'generic.log_in' | translate }}</span> <i class="icon icon-sign-in"></i>
      </button>
    </div>
  }
  <app-loyalty-club-footer/>
</div>
